<div fxLayout="column" fxFlex="100">
    <div fxLayout="row" fxFlex="100">
        <mat-horizontal-stepper headerPosition="bottom" #stepper style="width: 100%;">
            <mat-step>
                <ng-template matStepLabel>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon>settings</mat-icon>
                        <h3>Ρυθμίσεις φόρμας</h3>
                    </div>
                </ng-template>
                    <div fxLayout="column" fxFlex="100">
                        <div fxLayout="row" fxFlex="100">
                            <img src="assets/images/s1.PNG" alt="ss1"/>
                        </div>

                        <div fxLayout="row" fxFlex="100">
                            <div fxLayout="column" fxFlex="100">
                                <ol type="1">
                                    <li>
                                        <template fxLayout="row">
                                            <label fxFlex="50">Προσθήκη γραμμής</label>
                                            <label>Προσθήκη γραμμής</label>
                                        </template>
                                    </li>

                                    <li>
                                        <template fxLayout="row">

                                            <label fxFlex="50">Πρότυπα</label>
                                            <label>Πρότυπα</label>
                                        </template>
                                    </li>

                                    <li>
                                        <template fxLayout="row">

                                            <label fxFlex="50">Ρυθμίσεις</label>
                                            <label>Ρυθμίσεις</label>
                                        </template>
                                    </li>

                                    <li>
                                        <template fxLayout="row">

                                            <label fxFlex="50">Προεπισκόπηση</label>
                                            <label>Προεπισκόπηση</label>
                                        </template>
                                    </li>

                                    <li>
                                        <template fxLayout="row">

                                            <label fxFlex="50">Αποθήκευση</label>
                                            <label>Αποθήκευση</label>
                                        </template>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button mat-button matStepperNext>Next</button>
                    </div>
            </mat-step>
            <mat-step>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>add</mat-icon>
                    <h3>Προσθήκη πεδίου</h3>
                </div>
                <div>
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-button matStepperNext>Next</button>

                </div>
            </mat-step>
            <mat-step>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>settings</mat-icon>
                    <h3>Ρυθμίσεις γραμμής</h3>
                </div>
                    <mat-form-field>
                        <input matInput placeholder="Address" formControlName="secondCtrl" required>
                    </mat-form-field>
                    <div>
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-button matStepperNext>Next</button>
                    </div>
            </mat-step>
            <mat-step>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>settings</mat-icon>
                    <h3>Ρυθμίσεις πεδίου</h3>
                </div>
                <div>
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-button matStepperNext>Next</button>
                </div>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon>help</mat-icon>
                        <h3>Βοήθεια</h3>
                    </div>
                </ng-template>
                <div>
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-button (click)="stepper.reset()">Reset</button>
                </div>
            </mat-step>


        </mat-horizontal-stepper>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
        <button mat-flat-button class="left-side-buttons" (click)="close()">Το κατάλαβα</button>
    </div>
</div>
